// 按照拼音/壁畫過濾數據
export function toPYorBH(secondList: Record<string, any>[], searchModel: Record<string, any>) {
  if (!secondList) {
    return []
  }
  if (!secondList.length) {
    return secondList
  }
  return secondList.filter((v) => {
    if (searchModel.dictionaryType === 'strokes' && searchModel?.strokesValue?.min) {
      // 筆畫
      if (v.strokeNumber >= searchModel?.strokesValue?.min && v.strokeNumber <= searchModel?.strokesValue?.max) {
        return true
      }
      return false
    } else if (searchModel.dictionaryType === 'spell' && searchModel?.spellValue) {
      // 拼音
      if (v.pinyin && searchModel?.spellValue.includes(v.pinyin.charAt(0))) {
        return true
      }
      return false
    }
    return true
  })
}

// 排序
export function sortCompare(klist: string | string[], type: string | string[], list: Record<string, any>[]) {
  const kArr = typeof klist === 'string' ? [klist] : klist
  const typeArr = typeof type === 'string' ? [type] : type
  return list.sort((a, b) => {
    let k = ''
    let t = ''
    kArr.some((kv, ki) => {
      if (a[kv] !== b[kv]) {
        k = kv
        t = typeArr[ki]
        return true
      }
      return
    })
    if (typeof a[k] === 'number' || typeof b[k] === 'number') {
      if (t === 'up') {
        return a[k] - b[k]
      } else if (t === 'down') {
        return b[k] - a[k]
      }
    } else {
      if (t === 'up') {
        return a[k].localeCompare(b[k], 'zh-Hans-CN', {
          numeric: true,
          sensitivity: 'accent',
        })
      } else if (t === 'down') {
        return b[k].localeCompare(a[k], 'zh-Hans-CN', {
          numeric: true,
          sensitivity: 'accent',
        })
      }
    }
    return 1
  })
}

// 按照输入过滤数据
const toInputSearch = (str: string, list: Record<string, any>[]) => {
  // console.log('toInputSearch == ', str, list)
  if (!str) return list
  return list.filter((item) => {
    const { name = '' } = item
    const pinyin = item?.pinyin?.toLowerCase?.()
    // 如果list(name)包含key(输入框) => true
    if (name.includes(str) || pinyin.includes(str.toLowerCase())) {
      // 返回item
      return true
    }
    return false
  })
}
export { toInputSearch }

// 补零函数
export function zeroPadWithSuffix(digit, number) {
  // 校验 n 是否合法（1 ≤ n ≤ 9）
  if (digit < 1 || digit >= 10) {
    throw new Error('补零长度 n 必须是大于 0 且小于 10 的整数')
  }

  // 校验 d 是否合法（1~4 位字符串）
  if (typeof number !== 'string' || number.length < 1 || number.length > 4) {
    throw new Error('d 必须是 1~4 位的字符串')
  }

  // 计算需要补零的位数
  const zeroCount = digit - number.length

  // 如果 d 的长度已经 ≥ n，直接返回 d（但只取后 n 位）
  if (zeroCount <= 0) {
    return number.slice(-digit) // 只保留后 n 位
  }

  // 补零并拼接
  return '0'.repeat(zeroCount) + number
}

// 去除对象中所有属性的前后空格
export function safeTrimObjectValues(obj) {
  if (!obj || typeof obj !== 'object') return obj

  return Object.keys(obj).reduce((acc, key) => {
    const value = obj[key]
    acc[key] = typeof value === 'string' ? value.trim() : value
    return acc
  }, {})
}

// 递归版本 - 去除对象中所有属性的前后空格
export function deepTrimObjectValues(obj) {
  if (typeof obj !== 'object' || obj === null) {
    return typeof obj === 'string' ? obj.trim() : obj
  }

  if (Array.isArray(obj)) {
    return obj.map((item) => deepTrimObjectValues(item))
  }

  const result = {}
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      result[key] = deepTrimObjectValues(obj[key])
    }
  }

  return result
}
/**
 * 生成基于时间戳的不重复18位数字字符串
 * @returns {string} 长度为18的纯数字字符串
 */
export function getUnique18DigitString() {
  // 1. 获取当前毫秒级时间戳（字符串格式）
  const timestamp = Date.now().toString()
  // 2. 计算需要补充的随机数长度（18 - 时间戳长度）
  const randomLength = 18 - timestamp.length
  // 3. 生成对应长度的随机数字字符串
  let randomStr = ''
  for (let i = 0; i < randomLength; i++) {
    randomStr += Math.floor(Math.random() * 10)
  }
  // 4. 拼接时间戳和随机数，得到18位数字字符串
  const unique18Digit = timestamp + randomStr
  // 兜底：若因时间戳长度变化导致超出18位，截取后18位（确保长度严格为18）
  return unique18Digit.slice(-18)
}
